import { useEffect, useState } from "react";
import { Phone, CalendarCheck, Database, CheckCircle2 } from "lucide-react";
import { DemoTag } from "./Primitives";

const SCRIPT = [
  { who: "caller", text: "I'd like to schedule an appointment." },
  { who: "ai", text: "Absolutely. What day works best for you?" },
  { who: "caller", text: "Thursday afternoon, if you have anything." },
  { who: "ai", text: "I have 2:15pm or 4:00pm on Thursday. Which would you prefer?" },
  { who: "caller", text: "2:15pm works." },
  { who: "ai", text: "Booked for Thursday at 2:15pm. I'll send a confirmation now." },
];

const STEPS = [
  ["Google Calendar", "Availability checked", CalendarCheck],
  ["Availability", "2 slots offered", CheckCircle2],
  ["Appointment", "Created for Thu 2:15pm", CalendarCheck],
  ["CRM", "Record updated + follow-up queued", Database],
];

export default function ReceptionistDemo() {
  const [shown, setShown] = useState(1);

  useEffect(() => {
    const id = setInterval(() => setShown((v) => (v >= SCRIPT.length ? 1 : v + 1)), 1600);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="receptionist-demo" className="grid gap-5 lg:grid-cols-[1.15fr_1fr]">
      <div className="glass rounded-xl p-5 sm:p-6">
        <div className="flex items-center justify-between gap-3 border-b border-elv-line pb-4">
          <span className="flex items-center gap-2 text-xs text-elv-text">
            <Phone className="h-4 w-4 text-elv-green" />
            Inbound call · AI Receptionist
          </span>
          <DemoTag testId="receptionist-demo-tag">Demonstration</DemoTag>
        </div>
        <div className="mt-5 space-y-3">
          {SCRIPT.slice(0, shown).map((line, i) => (
            <div
              key={i}
              data-testid={`receptionist-line-${i}`}
              className={`max-w-[85%] rounded-lg border px-3.5 py-2.5 text-sm reveal ${
                line.who === "ai"
                  ? "ml-auto border-elv-green/25 bg-elv-green/[0.07] text-elv-text"
                  : "border-white/[0.07] bg-white/[0.025] text-elv-dim"
              }`}
            >
              <span className="mb-1 block text-[10px] uppercase tracking-[0.2em] text-elv-dim">
                {line.who === "ai" ? "AI" : "Caller"}
              </span>
              {line.text}
            </div>
          ))}
        </div>
      </div>

      <div className="grid gap-3">
        {STEPS.map(([title, detail, Icon], i) => (
          <div
            key={title}
            data-testid={`receptionist-step-${i}`}
            className="glass glass-hover flex items-start gap-3 rounded-lg p-4"
          >
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-elv-cyan" />
            <div>
              <p className="text-sm font-medium text-elv-text">{title}</p>
              <p className="mt-1 text-xs text-elv-dim">{detail}</p>
            </div>
          </div>
        ))}
        <p className="text-[11px] leading-relaxed text-elv-dim">
          Voice, calendar and messaging providers must be connected with your own credentials before any of
          this runs against real calls. Nothing above is a live integration.
        </p>
      </div>
    </div>
  );
}
